import React, { useEffect, useState } from "react";

function Navbar() {
    const [activePage, setActivePage] = useState(window.location.pathname);

    const handleNavigation = (path) => {
        setActivePage(path); // Update active state
        window.location.href = path; // Forces full-page reload
    };

    return (
        <div className="header-navbar">
            <div className="container-fluid">
                <div className="d-flex align-items-center justify-content-between">
                    <div className="navbar-left d-flex align-items-center">
                        <div className="site-logo">
                            <a href="/" onClick={(e) => { e.preventDefault(); handleNavigation("/"); }}>
                                <img src="assets/img/Logomainout.png" alt="Pixila" />
                            </a>
                        </div>
                        <nav className="site-nav-menu">
                            <ul className="primary-menu onepage-nav">
                                <li>
                                    <a 
                                        href="/" 
                                        onClick={(e) => { e.preventDefault(); handleNavigation("/"); }}
                                        className={activePage === "/" ? "active" : ""}
                                    >Home</a>
                                </li>
                                <li>
                                    <a 
                                        href="/service" 
                                        onClick={(e) => { e.preventDefault(); handleNavigation("/service"); }}
                                        className={activePage === "/service" ? "active" : ""}
                                    >Services</a>
                                </li>
                                <li>
                                    <a 
                                        href="/about" 
                                        onClick={(e) => { e.preventDefault(); handleNavigation("/about"); }}
                                        className={activePage === "/about" ? "active" : ""}
                                    >About Us</a>
                                </li>
                                <li>
                                    <a 
                                        href="/price" 
                                        onClick={(e) => { e.preventDefault(); handleNavigation("/price"); }}
                                        className={activePage === "/price" ? "active" : ""}
                                    >Pricing</a>
                                </li>
                                <li>
                                    <a 
                                        href="/contact" 
                                        onClick={(e) => { e.preventDefault(); handleNavigation("/contact"); }}
                                        className={activePage === "/contact" ? "active" : ""}
                                    >Contact</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div className="navbar-right d-flex align-items-center">
                    <div class="search-widget">
                            <a href="#" class="search-icon">
                                <i class="fal fa-search"></i>
                            </a>
                            <div className="search-form">
                                <form action="#">
                                    <input type="search" placeholder="Search here...."/>
                                    <button type="submit"><i class="fal fa-search"></i></button>
                                </form>
                            </div>
                        </div>
                        <a href="#" class="nav-toggler">
                            <i class="fal fa-bars"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Navbar;
